import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Container,
    ProgressBar,
    ProgressFill,
    ProgressText,
    Title,
    IndeterminateBar,
    IndeterminateFill,
} from './LoadingStep.style';

export type LoadingStepProps = {
    progress: number;
};

export const LoadingStep: React.FunctionComponent<LoadingStepProps> = ({ progress }) => {
    const isReading = progress === 0;

    return (
        <Container>
            <Title>
                <FormattedMessage
                    id={isReading ? 'customer.modal.import.loading.reading' : 'customer.modal.import.loading.importing'}
                />
            </Title>
            {isReading ? (
                <IndeterminateBar>
                    <IndeterminateFill />
                </IndeterminateBar>
            ) : (
                <>
                    <ProgressBar>
                        <ProgressFill progress={progress} />
                    </ProgressBar>
                    <ProgressText>{progress}%</ProgressText>
                </>
            )}
        </Container>
    );
};
